import {
  CustomGetDailyFormWorkOrdersQuery,
  CustomGetDailyFormWorkOrdersQueryVariables,
  useCustomGetDailyFormWorkOrdersQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetDailyFormWorkOrdersForTable({
  variables,
}: {
  variables?: CustomGetDailyFormWorkOrdersQueryVariables;
} = {}) {
  const {
    data: graphqlData,
    error,
    loading,
    fetchMore: more,
  } = useCustomGetDailyFormWorkOrdersQuery({
    variables: {
      first: 50,
      ...variables,
    },
  });

  const getData = useCallback((data?: CustomGetDailyFormWorkOrdersQuery) => {
    return data?.getDailyFormWorkOrders?.data || [];
  }, []);

  const getPaginatorInfo = useCallback((data?: CustomGetDailyFormWorkOrdersQuery) => {
    return data?.getDailyFormWorkOrders?.paginatorInfo;
  }, []);

  const data = useMemo(() => getData(graphqlData), [getData, graphqlData]);
  const paginatorInfo = useMemo(
    () => getPaginatorInfo(graphqlData),
    [getPaginatorInfo, graphqlData]
  );

  const fetchMore = useCallback(
    async ({ page }: { page: number }) => {
      return more({
        variables: {
          page,
        },
      });
    },
    [more]
  );

  return { data, error, loading, fetchMore, paginatorInfo } as const;
}
